import colors from "../colors";
import ramp from "../ramp";

export var scheme = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(colors);

export default ramp(scheme);



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/sequential-multi/OrRd.js
// module id = +7Si
// module chunks = 0